import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import {PropsWithChildren, ReactElement} from "react";

function Title(props: Readonly<PropsWithChildren>): ReactElement {
  return (
    <Typography component="h2" variant="h6" color="primary" gutterBottom>
      {props.children}
    </Typography>
  );
}

Title.propTypes = {
  children: PropTypes.node,
};

export default Title;
